import { Image } from "components";
import type { ImageProps } from "./Image.d";

const ImageMagnitudeAdapter = ({ props: [src, alt] }: ImageProps) =>
  src ? <Image srcDesktop={src} alt={alt} /> : null;

export default ImageMagnitudeAdapter;
